export const ItemRoutes = { path: 'item/*', lazy: () => import('../pages/item') };
